import { useState } from "react";
import classNames from "classnames";

// Components
import BonusCardBack from "components/molecules/BonusCardBack";
import BonusCardFace from "components/molecules/BonusCardFace";

// Types
import { BONUS_STATUS, BonusListType } from "types/Bonus";

import "./styles.sass";

type BonusCardProps = {
  bonus: BonusListType;
  setCanceledBonus?: (bonus: BonusListType) => void;
  currency: string;
};

const BonusCard = (props: BonusCardProps) => {
  const { bonus, setCanceledBonus, currency } = props;
  const [isOpen, setIsOpen] = useState(false);

  const clickInfo = () => {
    setIsOpen(!isOpen);
  };

  const BonusClass = classNames("BonusCard", {
    inverted: isOpen,
    // eslint-disable-next-line camelcase
    BonusCard_deactive:
      bonus.status.toLowerCase() === BONUS_STATUS.DEACTIVE ||
      bonus.status.toLowerCase() === BONUS_STATUS.AVAILABLE ||
      bonus.status.toLowerCase() === BONUS_STATUS.AVAILABLE_QUEUE,
  });

  return (
    <div className="BonusCardContainer">
      <div className="BonusCardContainer__wrapper">
        <div className={BonusClass}>
          <BonusCardFace
            bonus={bonus}
            currency={currency}
            setCanceledBonus={setCanceledBonus}
            clickInfo={clickInfo}
          />
          <BonusCardBack bonus={bonus} clickInfo={clickInfo} />
        </div>
      </div>
    </div>
  );
};

export default BonusCard;
